import React, { memo, useContext } from 'react';
import { useSelector } from 'react-redux';

import BackButton from '@/views/components/BackButton/BackButton';

import { ModalContext } from '@/utils/contexts/ModalContext';

import styles from '@/views/pages/Template/Template.module.scss';

const TemplateCreateHeader = ({ title = '', titleType = null, mode = 'EDIT_MODE', letterData, templateData }) => {
	const { dict } = useSelector((state) => state.app);

	const { showModal } = useContext(ModalContext);

	const onEdit = () => {
		window.location.href = `/edit-template/${templateData.id}`;
	};

	return (
		<section className={ styles['template-header'] }>
			<div className={ styles['template-header--inner'] }>
				<div className={ styles['template-header--back-title'] }>
					<div className={ styles['template-header--back-container'] }>
						<BackButton
							url={ mode === 'USE_MODE' || mode === 'EDIT_MODE' ? '/templates' : '/letters' }
							title={ dict.returnTemplate }
						/>

					</div>
					{mode === 'USE_MODE' && <div className={ styles['template-header--prefix-wrapper'] }>
						<p className={ styles['template-header--prefix'] }>{dict.templates.create.usingTemplate}: </p>
					</div>}
					{(mode === 'CREATE_MODE' || mode === 'EDIT_MODE') && <div className={ styles['template-header--prefix-wrapper'] }>
						<p className={ styles['template-header--prefix'] }>{dict.templates.create.creatingTemplateBasedOn}: </p>
					</div>}
					<div className={ styles['template-header--title-wrapper'] }>
						<p className={ styles['template-header--title'] }>{title} {titleType && (<span>({dict.titletypes[titleType] ? dict.titletypes[titleType].toUpperCase() : ''} )</span>)}</p>
					</div>
					<div className={ styles['template-header__right-side'] }>
						{(mode !== 'USE_MODE') && letterData && <div className={ styles['template-header__right-side__metadata'] }>
							<p
								className={ styles['template-header__right-side__metadata--text'] }
								onClick={ () => {
									showModal({
										componentName: 'ModalLetterMetadata',
										additionalInfo: {
											letterData: letterData,
										},
									});
								} }
							>
								{dict.templates.create.showMetadata}
							</p>
						</div>}
						{(mode === 'USE_MODE') && (templateData && templateData.rights.canEdit) && <div className={ styles['template-header__right-side__edit'] }>
							<p 
								className={ styles['template-header__right-side__edit--text'] }
								onClick={ onEdit }
							>
								{dict.templates.create.editTemplate}
							</p>
						</div>}
					</div>
				</div>
			</div>
		</section>
	);
};

export default memo(TemplateCreateHeader);